import { downloadFileAsJSBlob } from 'utils/functions/downloadFile/downloadFileAsJSBlob';

export const downloadCustomTextFile = (text: string, fileName: string): void => {
  const fileContentBlob = new Blob([text], { type: 'text/plain' });
  downloadFileAsJSBlob(fileContentBlob, fileName);
};
